export const toRadians = (degrees: number) => (Math.PI / 180) * degrees
